<template>

  <div>
    <CreateCard model_name="Teste" route_back="Suppliers">
      <template slot="title">
        <v-row>
          <v-col cols="12" class="d-flex justify-center pa-0 ma-0 font-weight-light">
            <span>Selecione o que adicionar:</span>
          </v-col>
          <v-col cols="12">
            <v-tabs v-model="supplier_tab" class="d-flex justify-center">
              <v-tab>
                <v-icon left>mdi-factory</v-icon> 
                Marca
              </v-tab>
              <v-tab>
                <v-icon left>mdi-information</v-icon> 
                Segmento
              </v-tab>
              <v-tab>
                <v-icon left>mdi-package</v-icon> 
                Produto
              </v-tab>
              <v-tab>
                <v-icon left>mdi-map-marker</v-icon> 
                Local de Retirada
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12">
            <h2 class="mx-2">Cadastro de {{model_map[supplier_tab]}}</h2>
          </v-col>
        </v-row>
      </template>
      <template slot="form">
        <card-loading-transparent v-if="loading.brands"></card-loading-transparent>
        <v-tabs-items v-model="supplier_tab" v-if="!loading.brands">
          <v-tab-item>
            <register-brand :brands="brands"></register-brand>
          </v-tab-item>
          <v-tab-item>
            <register-segment></register-segment>
          </v-tab-item>
          <v-tab-item>
            <register-product :brands="brands"></register-product>
          </v-tab-item>
          <v-tab-item>
            <register-pickup-location :brands="brands"></register-pickup-location>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </CreateCard>
  </div>

</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from "@/api/index"

export default {
  name: 'CreateSupplierModels',
  components: {
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    RegisterSegment: () => import('./register/suppliers/RegisterSegment.vue'),
    RegisterProduct: () => import('./register/suppliers/RegisterProduct.vue'),
    RegisterBrand: () => import('./register/suppliers/RegisterBrand.vue'),
    RegisterPickupLocation: () => import('./register/suppliers/RegisterPickupLocation.vue'),
  },
  data() {
    return {
      brands: [],
      model_map: ["Marca","Segmento","Produto","Local de retirada"],
      supplier_tab: 0,
      loading: {
        brands: false
      },
    }
  },
  methods: {
    getData(){
      this.getBrands()
      this.getCompanies();
    },
    getBrands(){
      this.loading.brands = true
      Api.SupplierV2.index('brands').then(req => req.data).then(data => {
        this.brands = data.map(b => ({ ...b, id: Number(b.id) }))
      }).finally(()=>{
        this.loading.brands = false
      })
    },  
    ...mapActions({
      getProducts: 'Supplier/index',
      getMarkets: 'Supplier/index',
      getCompanies: 'Company/index',
      clearAllSuppliers: 'Supplier/clearAllSuppliers',
    })
  },
  computed: mapState({
    all_products: state => state.Supplier.all_products,
  }),
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    this.clearAllSuppliers({ type: 'brands' })
    this.clearAllSuppliers({ type: 'products' })
    this.clearAllSuppliers({ type: 'pickup_locations' })
  }
}
</script>

<style scoped>

</style>